import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();
  return {
    grid: {
      display: 'grid',

      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateRows: 'auto',
      gridTemplateAreas: `
      "name empty submit"
    `,
      width: '100%',
    },
    nameArea: {
      gridArea: 'name',
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      backgroundColor: '#fff',
    },
    emptyArea: {
      gridArea: 'empty',
      alignSelf: 'center',
    },
    submitArea: {
      gridArea: 'submit',
      backgroundColor: '#fff',
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
    },

    input: {
      marginRight: theme.spacing(),
    },
    inputAdornmentErrorIcon: {
      cursor: 'default',
      color: theme.palette.error.main,
    },
  };
};
